import { Add } from '@mui/icons-material';
import {
  Button,
  FormControl,
  FormLabel,
  ListSubheader,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { useAssortmentTFunction } from '@retail/monitoring-assortment/i18n';
import { MonitoringAssortment } from '@retail/monitoring-assortment/types';

interface Props {
  assortments: MonitoringAssortment[];
  selectedAssortment: MonitoringAssortment | null;
  setSelectedAssortment: (assortment: MonitoringAssortment | null) => void;
  openCreateManuallyModal: () => void;
}

export function AddOrSelectAssortmentDropdown({
  selectedAssortment,
  assortments,
  setSelectedAssortment,
  openCreateManuallyModal,
}: Props) {
  const t = useAssortmentTFunction();

  return (
    <FormControl sx={{ flexDirection: 'row', alignItems: 'center', gap: 1 }}>
      <FormLabel id="assortmentSelect" htmlFor="assortmentSelect">
        {t('assortment.chooseAssortment')}:
      </FormLabel>
      <Select
        id="assortmentSelect"
        labelId="assortmentSelect"
        displayEmpty
        value={selectedAssortment?.id ?? 'placeholder'}
        renderValue={(value) =>
          value === 'placeholder' ? (
            <Typography color="textDisabled"> {t('assortment.assortment.singular')}</Typography>
          ) : (
            selectedAssortment?.title
          )
        }
        sx={{ width: 260 }}
        onChange={(event) => {
          const chosenAssortment = assortments.find(
            (assortment) => assortment.id === event.target.value
          );
          setSelectedAssortment(chosenAssortment || null);
        }}
        data-testid="add-or-select-assortment-dropdown"
      >
        <MenuItem disabled value="placeholder">
          {t('assortment.chooseAssortment')}
        </MenuItem>
        <ListSubheader>{t('assortment.admin.update.import.addOrReplace.add')}</ListSubheader>
        <MenuItem LinkComponent={Button} onClick={openCreateManuallyModal}>
          {t('assortment.newAssortment')}
          <Add />
        </MenuItem>
        {assortments.length > 0 && (
          <ListSubheader>{t('assortment.addToExistingAssortment')}</ListSubheader>
        )}
        {assortments.map((assortment) => {
          return (
            <MenuItem key={assortment.id} value={assortment.id}>
              {assortment.title}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
